import { ReactElement, cloneElement } from 'react';

import styled from 'styled-components';

import { IconProps } from '@components/icons';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type IconShadowContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  icon: ReactElement<IconProps>;
  containerSize?: number;
  iconSize?: number;
  shadowSize?: number;
};

export const IconShadowContainer = ({
  icon,
  containerSize = 64,
  iconSize = 32,
  shadowSize = 120,
  ...rest
}: IconShadowContainerProps) => {
  const iconElement = cloneElement(icon, { ...icon.props, size: iconSize });
  const iconShadowElement = cloneElement(icon, { ...icon.props, size: shadowSize });

  return (
    <Container $size={containerSize} {...rest}>
      <Shadow>{iconShadowElement}</Shadow>
      <Center>{iconElement}</Center>
    </Container>
  );
};

const Container = styled.div<{ $size: number }>(({ $size }) => ({
  '--icon-color': theme.color.elementPurpleInvert,
  position: 'relative',
  width: pxToRem($size),
  height: pxToRem($size),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.color.backgroundLightDark,
  boxShadow: theme.shadow.fancy,
  borderRadius: pxToRem(8),
  overflow: 'hidden',
  flexShrink: 0,
}));

const Center = styled.div({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const Shadow = styled.div({
  '--icon-color': theme.color.elementPurpleInvert,
  position: 'absolute',
  right: 0,
  bottom: 0,
  zIndex: 0,
  opacity: 0.05,
});
